const appendContextToAiMessages = (context, messages) => {
  const contextString = JSON.stringify(context);
  const contextMessage = `Please consider the following context for this conversation: ${contextString}

    Use this context to:
    1. Understand the current state and environment
    2. Provide more relevant and contextual responses
    3. Reference specific details from the context when applicable

    Please acknowledge this context in your response only if directly relevant to the user's question.`;

  const filteredMessages = messages.slice(messages.findLastIndex((msg) => msg.role === 'system')).filter(Boolean);

  return [
    ...filteredMessages.slice(0, -1),
    {
      role: 'user',
      content: `${contextMessage}\n\n${filteredMessages[filteredMessages.length - 1].content}`
    }
  ];
};

export default appendContextToAiMessages;
